import type { Texts } from '../useTexts'
import { useValidateEmail } from './useValidateEmail'

type ValidateEmail = ReturnType<typeof useValidateEmail>

export const createValidateEmail = async (
  texts: Texts,
  email: string,
  validateEmail: ValidateEmail,
) => {
  const emailRequiredError = {
    id: 'emailRequiredError',
    message: texts.emailRequired,
    field: 'email',
    priority: 10,
  }

  const emailValidError = {
    id: 'emailValidError',
    message: texts.emailInvalid,
    field: 'email',
    priority: 10,
  }

  const requiredError = email.trim().length === 0
  const valid = requiredError ? true : await validateEmail(email)

  return {
    [emailRequiredError.id]: requiredError ? emailRequiredError : undefined,
    [emailValidError.id]: !valid ? emailValidError : undefined,
  }
}
